import React, { useState } from 'react';
import { Button } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { ModalDestroy } from '../ModalDestroy';

import { I18n } from '@aws-amplify/core';

interface ButtonDeleteProps {
	attachmentId: string;
	disabled?: boolean;
	onDelete: () => void;
}

export function ButtonDelete({ onDelete, disabled = false }: Readonly<ButtonDeleteProps>) {
	const [isOpen, setIsOpen] = useState<boolean>(false);

	function handleOnClick(): void {
		setIsOpen(true);
	}

	function handleOnCancel(): void {
		setIsOpen(false);
	}

	async function handleOnConfirm(): Promise<void> {
		onDelete();
		handleOnCancel();
	}

	return (
		<>
			<Button danger type="ghost" icon={<DeleteOutlined />} disabled={disabled} onClick={handleOnClick} />
			<ModalDestroy
				open={isOpen}
				onCancel={handleOnCancel}
				onConfirm={handleOnConfirm}
				description={I18n.get('Are you sure you want to delete this file?')}
			/>
		</>
	);
}
